export { scaleWholeRangeSize } from './utils';
export { wilkinsonExtended } from './tick-wilkinson-extended';
